import { motion } from 'framer-motion';
import { styled, Typography } from 'shared/Houston';

import { css } from '@eduzz/houston-styles/styled';

export const Overlay = styled.div<{ maxHeight?: string }>`
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: ${({ maxHeight }) => maxHeight || 'initial'};
  background-color: rgba(0, 0, 0, 0.5) !important;
  cursor: pointer;
  z-index: 115;
  overscroll-behavior: none;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalContainer = styled(motion.div)<{ small?: boolean }>`
  width: ${({ small }) => (small ? '380px' : '90%')};
  max-width: 800px;
  height: auto;
  background-color: #fff;
  position: absolute;
  border-radius: ${({ theme }) => theme.border.radius.xs};
  cursor: initial;
  box-sizing: initial;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.25);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${({ theme }) => theme.spacing.xxxs};
  .default {
    color: ${({ theme }) => theme.neutralColor.low.dark};
  }

  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: ${theme.spacing.inline.xxxs};
      align-items: center;
    }
  `}
`;

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.neutralColor.low.dark};
`;

export const CloseIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex: 0;
  width: 18px;
  height: 18px;

  &:hover {
    opacity: 0.8;
  }
`;

export const Content = styled.div`
  max-height: 50%;
`;

export const Footer = styled.div`
  padding: ${({ theme }) => theme.spacing.xxxs};
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints.md}) {
      align-items: center;
      padding: ${theme.spacing.inline.xxxs};
    }
  `}
`;
